import {TimelineGraphContainer} from 'apstra-ui-common';
import {sortBy, isUndefined, filter, cloneDeep} from 'lodash';
import moment from 'moment';

import StateLineChart from '../StateLineChart';

const AnomalyHistory = ({
  axes,
  samples = [],
  color = 'blue',
  expanded = false,
  valueKeyName = 'raised',
  extraDataKey = 'data',
  periodStartKey = 'detected_at',
  timelineStart,
  timelineEnd,
  useCurrentTimeAsTimelineEnd = false,
  popupProps = {},
  useTimestampZoom = false,
  showStandaloneSamples = false,
  selectedTimestamp,
  onSelectTimestamp,
  selectedSampleId,
  onSelectSample,
  generatePopupContentFn,
}) => {
  const sortedSamples = sortBy(samples, 'timestamp');
  let samplesWithCornerValues = cloneDeep(sortedSamples);

  if (samples.length > 0) {
    if (!isUndefined(timelineStart)) {
      samplesWithCornerValues.unshift({
        ...(!moment(sortedSamples[0]?.timestamp).isAfter(timelineStart) ? sortedSamples[0] : {}),
        timestamp: timelineStart,
        [valueKeyName]: moment(sortedSamples[0]?.timestamp).isAfter(timelineStart)
          ? null
          : sortedSamples[0][valueKeyName],
      });
    }

    if (!isUndefined(timelineEnd) && moment(sortedSamples[sortedSamples.length - 1]?.timestamp).isBefore(timelineEnd)) {
      samplesWithCornerValues.push({
        timestamp: timelineEnd,
        [valueKeyName]: null,
      });
    }

    if (!isUndefined(timelineStart) && !isUndefined(timelineEnd)) {
      samplesWithCornerValues = filter(
        samplesWithCornerValues,
        ({timestamp}) => moment(timestamp).isBetween(timelineStart, timelineEnd, undefined, '[]')
      );
    }
  }

  return (
    <TimelineGraphContainer
      axes={axes}
      samples={samplesWithCornerValues}
      expanded={expanded}
      useCurrentTimeAsTimelineEnd={useCurrentTimeAsTimelineEnd}
    >
      <StateLineChart
        color={color}
        chartStart={timelineStart}
        chartEnd={timelineEnd}
        valueKeyName={valueKeyName}
        extraDataKey={extraDataKey}
        periodStartKey={periodStartKey}
        popupProps={popupProps}
        useTimestampZoom={useTimestampZoom}
        showStandaloneSamples={showStandaloneSamples}
        selectedTimestamp={selectedTimestamp}
        onSelectTimestamp={onSelectTimestamp}
        selectedSampleId={selectedSampleId}
        onSelectSample={onSelectSample}
        generatePopupContentFn={generatePopupContentFn}
      />
    </TimelineGraphContainer>
  );
};

export default AnomalyHistory;
